// extracted by mini-css-extract-plugin
export default {"body":"style_body__EU3sR","container":"style_container__FsrpW","action":"style_action__D3rmY"};